/*!

=========================================================
* Purity UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import {
  Avatar,
  AvatarGroup,
  Badge,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar8 from "assets/img/avatars/avatar8.png";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { HSeparator } from "components/Separator/Separator.js";
import React from "react";
import { IoIosStar, IoMdStarHalf } from "react-icons/io";
import { IoEllipsisVerticalSharp } from "react-icons/io5";

const ProfileStats = ({ rowOnClick, row, headerGroup }) => {
  console.log({ row, headerGroup });
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  return (
    <Card
      background="gray.100"
      mb="20px"
      onClick={() =>
        rowOnClick ? rowOnClick(row.original) : console.log(row.original)
      }
    >
      <CardHeader>
        <Flex justify="space-between" align="center" w="100%">
          <Text fontSize="lg" color={textColor} fontWeight="bold">
            <Text position={"absolute"}>{row.cells[0].render("Cell")}</Text>
            <Text paddingLeft={"6"} paddingTop={"0.5"}>
              {row.cells[1].render("Cell")}
            </Text>
          </Text>
        </Flex>
      </CardHeader>
      <CardBody>
        <Flex direction="column" mt="16px">
          <Text color="gray.400" fontWeight="normal" fontSize="md" mb="20px">
            {row.cells[3].render("Cell")}
          </Text>
          <Flex justify="space-between" align="center">
            <Text color="gray.400">
              {headerGroup.headers[5].render("Header")}:
            </Text>
            {row.cells[5].render("Cell")}
          </Flex>
          <HSeparator my="14px" />
          <Flex justify="space-between" align="center">
            <Text color="gray.400">
              {headerGroup.headers[4].render("Header")}:
            </Text>
            {row.cells[4].render("Cell")}
          </Flex>
          <HSeparator my="14px" />
          <Flex justify="space-between" align="center">
            <Text color="gray.400">
              {headerGroup.headers[2].render("Header")}:
            </Text>
            {row.cells[2].render("Cell")}
          </Flex>
          {false && (
            <Flex justify="space-between" align="center">
              <Text color="gray.400">Rating:</Text>
              <Stack direction="row" spacing="2px">
                <Icon as={IoIosStar} />
                <Icon as={IoIosStar} />
                <Icon as={IoIosStar} />
                <Icon as={IoIosStar} />
                <Icon as={IoMdStarHalf} />
              </Stack>
            </Flex>
          )}
          <HSeparator my="14px" />
          <Flex justify="space-between" align="center">
            {row.cells[6].render("Cell")}
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default ProfileStats;
